import CustomSelect from '../../../assets/scripts/classes/CustomSelect';

/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
document.addEventListener('DOMContentLoaded', () => {
  const customSelects = [...document.querySelectorAll('.custom-select')];
  customSelects.forEach(selectCont => {
    new CustomSelect(selectCont);
  });
});
